import {AddTeacherClassroomForm} from './TeacherAddClassroomForm';

export default AddTeacherClassroomForm;
